<template>
  <nav v-if="visibility" :class="`navigation navigation-${theme}`">
    <NavigationMenu parent="6"/>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex';
import NavigationMenu from '@/components/NavigationMenu';

export default {
  name: 'navigation',
  components: {
    NavigationMenu,
  },
  computed: mapGetters({
    theme: 'navigationTheme',
    visibility: 'navigationVisibility',
  }),
  created() {
    this.$store.dispatch('fetchNavigation', { lang: 2, $http: this.$http });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.navigation{
  font-size: 120%;
  white-space: normal;
  display: inline-block;
  vertical-align: middle;

  @media (max-width: 768px){
    margin-top: -5px;
    font-size: 110%;
  }

  li {
    margin-bottom: 0;
    margin-top: 5px;
  }

  &-white{
    &,
    a{
      color: white;

      &.router-link-exact-active{
        color: $brand;
      }
    }
    a:hover{
      color: $brand;
    }
  }

  &-active{
    color: black;
  }
}
</style>



// WEBPACK FOOTER //
// Navigation.vue?08159ad1